import React, { Component } from 'react';
import ErrorIcon from '@material-ui/icons/Close';
import CheckedIcon from '@material-ui/icons/Done';
import PropTypes from 'prop-types';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import { Checkbox } from '../../components';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = {
  answer: {
    marginBottom: 20,
  },
  selected: {
    borderColor: '#999',
  },
  wrong: {
    borderColor: '#d04f30',
  },
  correct: {
    borderColor: '#00921f',
  },
  neutral: {
    borderColor: '#999',
  },
  iconStyle: {
    width: 40,
    height: 40,
    marginLeft: -5,
    borderColor: '#999',
    fill: '#999',
  },
  iconStyleSmall: {
    width: 25,
    height: 25,
  },
};

const CustomCheckboxComponent = ({ icon, checked, label, onChange, style }) => (
  <FormControlLabel
    control={
      <MaterialCheckbox
        checked={checked}
        onChange={onChange}
        style={style}
        checkedIcon={icon}
      />
      }
    label={label}
  />
  );

class Answer extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  getStateClass() {
    if (!this.props.completed) {
      return null;
    }

    const answer = this.props.answer;
    if (answer.isValidAnswer) {
      if (answer.answeredCorrectly) {
        if (this.props.completed) {
          return styles.correct;
        }
        return styles.wrong;
      }
      return styles.wrong;
    } else if (!answer.isValidAnswer && answer.answeredCorrectly) {
      return styles.neutral;
    } else if (!answer.answeredCorrectly) {
      return styles.wrong;
    }

    return {};
  }

  renderImage(width) {
    if (!this.props.answer.imageUrl) return null;
    // const height = Math.min(((width / 3) * 2), 130);

    return (
      <div style={{ height: 200, width: '100%' }}>
        <img
          src={this.props.answer.imageUrl}
          // objectFit="contain"
          style={{ maxHeight: 200, width: 'auto' }}
          // style={{ height: '100%', maxWidth: '100%' }}
          alt="Bildantwort"
        />
      </div>
    );
  }

  renderCheckbox() {
    if (this.props.completed) {
      const style = this.getStateClass();
      const checkedIcon = (this.props.answer.isValidAnswer) ? null : <ErrorIcon />;
      const unCheckedIcon =
      (!this.props.answer.isValidAnswer && !this.props.answer.answeredCorrectly)
      ? <ErrorIcon />
      : null;

      let icon = null;
      let checked = true;
      const iconStyle = {
        ...(styles.iconStyleSmall),
        fill: style && style.borderColor };

      if (this.props.answer.answeredCorrectly &&
          !this.props.answer.isValidAnswer) {
        checked = false;
      } else if (this.props.answer.answeredCorrectly) {
        icon = <CheckedIcon style={iconStyle} />;
        checked = true;
      } else if (this.props.answer.isValidAnswer) {
        checked = false;
        // icon = <CheckedIcon style={iconStyle} />;
      } else {
        icon = <ErrorIcon style={iconStyle} />;
        checked = true;
      }

      return (
        <CustomCheckboxComponent
          style={{ ...style, ...{ color: style.borderColor } }}
          onChange={() => {}}
          label={this.props.answer.text}
          icon={icon}
          checked={checked}

        />);
    }

    return (
      <Checkbox
        style={{ display: 'block' }}
        iconStyle={styles.iconStyle}
        labelStyle={{ lineHeight: '40px' }}
        label={this.props.answer.text}
        onCheck={this.props.onCheck}
        checked={this.props.isSelected}
      />);
  }

  render() {
    if (!this.props.answer) {
      return null;
    }

    // const checked = (this.props.completed && this.props.answer.isValidAnswer);
    return (
      <div style={styles.answer} key={this.props.answer.id}>
        {this.renderCheckbox()}
        {this.renderImage(250)}
      </div>
    );
  }
}

Answer.propTypes = {
  answer: PropTypes.object,
  completed: PropTypes.bool,
  small: PropTypes.bool,
  isSelected: PropTypes.bool,
  onCheck: PropTypes.func,
};

Answer.defaultProps = {
  answer: null,
  completed: false,
  small: false,
  isSelected: false,
  onCheck: () => {},
};


export default Answer;



// WEBPACK FOOTER //
// ./src/app/components/question_answering/answer.js